var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "add-item-option-group" }, [
    _c(
      "div",
      {
        staticClass: "title",
        attrs: { tabindex: "0", "aria-label": _vm.getAriaLabel() },
      },
      [
        _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t\t"),
        _vm.required
          ? _c("span", { staticClass: "required-badge" }, [_vm._v("Required")])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "choose-between-text" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.getChooseBetweenText()) + "\n\t"),
    ]),
    _vm._v(" "),
    _vm.type == 2
      ? _c(
          "div",
          { staticClass: "choices-group" },
          _vm._l(_vm.choices, function (choice) {
            return _c("add-item-input-radio", {
              key: choice.id,
              attrs: {
                id: choice.id,
                value: choice.value,
                name: choice.name,
                label: choice.name,
                price: choice.price,
                isAlcohol: choice.isAlcohol,
                hasNestedOptions: _vm.hasNestedOptions(choice.id),
                allNestedOptionsSelected: _vm.allNestedOptionsSelected,
                parentID: _vm.parentID,
              },
              on: {
                input: _vm.handleOneSelect,
                editNestedSelections: _vm.handleEditNestedSelections,
              },
            })
          }),
          1
        )
      : _c(
          "div",
          { staticClass: "choices-group" },
          _vm._l(_vm.choices, function (choice) {
            return _c("add-item-input-checkbox", {
              key: choice.id,
              attrs: {
                id: choice.id,
                label: choice.name,
                value: choice.value,
                price: choice.price,
                isAlcohol: choice.isAlcohol,
                hasNestedOptions: _vm.hasNestedOptions(choice.id),
                allNestedOptionsSelected: _vm.allNestedOptionsSelected,
                parentID: _vm.parentID,
              },
              on: {
                input: _vm.handleManySelect,
                editNestedSelections: _vm.handleEditNestedSelections,
              },
            })
          }),
          1
        ),
    _vm._v(" "),
    _c("div", { staticClass: "add-item-footer" }, [
      _c("div", { staticClass: "nested-option-buttons" }, [
        _c(
          "button",
          {
            staticClass: "save-options-button",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("saveNestedOptions")
              },
            },
          },
          [_vm._v("Save Options")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }